var $ = require('jquery');

/**
 * NextPageLoader - dynamically loads next page items on button click
 * element @param jquery selector - context element
 * btn @param jquery selector - button
 */

var NextPageLoader = module.exports = function(element, btn) {
    this.elementSel = element;
    this.element = $(element);
    this.btnSel = btn;
    this.btn = this.element.find(btn);
    this.nextUrl = this.btn.attr('href');
    this.baseUrl = this.element.attr("data-section-url");
};

NextPageLoader.prototype = {

    init: function() {

        this._addListeners();
        if (this.nextUrl !== undefined) {
            this._ajaxCall(this.nextUrl, $.proxy(function(data){
                this._appendData(data);
            }, this));
        }
    },

    _addListeners: function() {
        this.btn.on('click', $.proxy(function(e) {
            this._ajaxCall(this.nextUrl, $.proxy(this._appendData, this));
            e.preventDefault();
        }, this));
    },

    _ajaxCall: function(url, callback) {
        this.xhr = $.ajax({
            url: url,
            success: $.proxy(function(data) {
                delete this.xhr;
                callback(data);
            }, this),
            error: $.proxy(function(xhr, status, error) {
                location.href = this.nextUrl;
            }, this)
        });
    },

    _appendData: function(data) {
        var t = this;
        var result = $(data).find(this.elementSel);
        var articles = result.find('.js_dynamicListItem');
        this.nextUrl = result.find(this.btnSel).attr('href');
        this.element.children('.row').append(articles);
        if (this.nextUrl !== undefined) {
            this.btn.attr('href', this.nextUrl);
            setTimeout(function() {t.btn.click()}, 500)   
        } else {
            this.btn.remove();
        }

    }
};


// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/autoNextPageLoader.js